module.exports = __webpack_public_path__ + "img/loudspeaker.72dff663.png";